// extracted by mini-css-extract-plugin
module.exports =  {"row":"_93444fe79c--row--BEEzo","labels":"_93444fe79c--labels--naJo0","label":"_93444fe79c--label--V1wQI"};